var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExvalSubtitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 431.894,
    height: 21.734,
    viewBox: "0 0 431.894 21.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_310",
    "data-name": "Groupe 310",
    transform: "translate(0 -143.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2460",
    "data-name": "Trac\\xE9 2460",
    d: "M9.474,55.774l-2.3-5.791H4.115v5.791H0V34.852H7.087a6.248,6.248,0,0,1,4.849,1.914,6.983,6.983,0,0,1,1.342,2.448,8.709,8.709,0,0,1,.4,2.981,10.508,10.508,0,0,1-.721,4.075,5.926,5.926,0,0,1-2.114,2.657l3.282,6.847ZM4.115,45.626h3a2.353,2.353,0,0,0,1.94-.841,3.367,3.367,0,0,0,.541-1.114,4.063,4.063,0,0,0,.143-1.311,3.906,3.906,0,0,0-.148-1.271,3.21,3.21,0,0,0-.535-1.072,2.377,2.377,0,0,0-1.94-.808h-3Z",
    transform: "translate(0 108.975)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2461",
    "data-name": "Trac\\xE9 2461",
    d: "M7.554,34.84H19.987V39.2H11.669v3.91h7.46V47.43h-7.46v3.943h8.554v4.356H7.554Z",
    transform: "translate(15.944 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2462",
    "data-name": "Trac\\xE9 2462",
    d: "M27.445,55.762l-1.082-3.712H19.55l-1.094,3.712H14.229L20.943,34.84H25.17l6.614,20.922Zm-6.652-7.887h4.364l-2.163-7.458Z",
    transform: "translate(30.034 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2463",
    "data-name": "Trac\\xE9 2463",
    d: "M22.666,34.84h4.091V51.059h6.676v4.669H22.666Z",
    transform: "translate(47.843 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2464",
    "data-name": "Trac\\xE9 2464",
    d: "M32.981,34.84H45.415V39.2H37.1v3.91h7.46V47.43H37.1v3.943h8.542v4.356H32.981Z",
    transform: "translate(69.617 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2465",
    "data-name": "Trac\\xE9 2465",
    d: "M49.154,39.836a6.09,6.09,0,0,0-2.4-.627,1.81,1.81,0,0,0-1.243.363,1.151,1.151,0,0,0-.328.466,1.556,1.556,0,0,0-.106.623,1.915,1.915,0,0,0,.1.635,1.528,1.528,0,0,0,.29.52,2.689,2.689,0,0,0,.945.743c.373.2.92.429,1.666.726a19.863,19.863,0,0,1,2.7,1.254,5.272,5.272,0,0,1,1.877,1.9,6.656,6.656,0,0,1,.758,3.3,7.157,7.157,0,0,1-.833,3.58,5.425,5.425,0,0,1-2.313,2.343,6.978,6.978,0,0,1-3.232.759,9.141,9.141,0,0,1-3.9-.924,10.16,10.16,0,0,1-3.32-2.459l1.6-4.257a9.816,9.816,0,0,0,2.822,2.293,6.152,6.152,0,0,0,2.884.891,2.208,2.208,0,0,0,1.455-.446,1.386,1.386,0,0,0,.394-.558,1.876,1.876,0,0,0,.128-.745,1.949,1.949,0,0,0-.1-.663,1.562,1.562,0,0,0-.3-.542,2.761,2.761,0,0,0-.982-.759c-.4-.182-.958-.412-1.679-.677a16.893,16.893,0,0,1-2.673-1.2,5.31,5.31,0,0,1-1.8-1.881,6.392,6.392,0,0,1-.746-3.3,7.1,7.1,0,0,1,.771-3.4,5.46,5.46,0,0,1,2.2-2.261,6.75,6.75,0,0,1,3.32-.792,9.229,9.229,0,0,1,3.37.644,10.076,10.076,0,0,1,2.934,1.65l-1.567,4.455A13.223,13.223,0,0,0,49.154,39.836Z",
    transform: "translate(84.018 108.66)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2466",
    "data-name": "Trac\\xE9 2466",
    d: "M46.73,34.84H60.245v4.5H55.533V55.762H51.418V39.345H46.743Z",
    transform: "translate(98.639 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2467",
    "data-name": "Trac\\xE9 2467",
    d: "M66.095,55.762l-1.107-3.712H58.175l-1.094,3.712H52.854L59.617,34.84h4.227l6.614,20.922Zm-6.652-7.887h4.364l-2.163-7.458Z",
    transform: "translate(111.563 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2468",
    "data-name": "Trac\\xE9 2468",
    d: "M60.315,34.84H73.831v4.5h-4.7V55.762H65.015V39.345H60.34Z",
    transform: "translate(127.314 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2469",
    "data-name": "Trac\\xE9 2469",
    d: "M67.514,34.84H79.947V39.2H71.629v3.91h7.46V47.43h-7.46v3.943h8.554v4.356H67.514Z",
    transform: "translate(142.508 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2470",
    "data-name": "Trac\\xE9 2470",
    d: "M91.33,55.762l-1.069-3.712H83.435l-1.094,3.712H78.113L84.877,34.84H89.1l6.614,20.922Zm-6.652-7.887h4.364l-2.164-7.458Z",
    transform: "translate(164.882 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2471",
    "data-name": "Trac\\xE9 2471",
    d: "M97.318,34.84h3.829V55.762H97.542L90.393,43.255V55.762H86.551V34.84h3.618L97.343,47.43Z",
    transform: "translate(182.692 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2472",
    "data-name": "Trac\\xE9 2472",
    d: "M107.258,55.762l-1.094-3.712H99.35l-1.107,3.712H94.017L100.78,34.84h4.227l6.615,20.922Zm-6.652-7.887h4.314l-2.164-7.458Z",
    transform: "translate(198.45 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2473",
    "data-name": "Trac\\xE9 2473",
    d: "M102.5,34.84h4.116V51.059h6.629v4.669H102.446Z",
    transform: "translate(216.243 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2474",
    "data-name": "Trac\\xE9 2474",
    d: "M123.954,34.84l-5.693,14.223v6.7h-4.116v-6.6L108.313,34.84h4.116l3.73,8.976L119.8,34.84Z",
    transform: "translate(228.627 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2475",
    "data-name": "Trac\\xE9 2475",
    d: "M115.676,34.84h13.513v4.5h-4.722V55.762h-4.116V39.345h-4.676Z",
    transform: "translate(244.169 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2476",
    "data-name": "Trac\\xE9 2476",
    d: "M122.878,34.84h4.116V55.762h-4.116Z",
    transform: "translate(259.371 108.987)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2477",
    "data-name": "Trac\\xE9 2477",
    d: "M137.762,40.1a3.561,3.561,0,0,0-2.087-.759,3.391,3.391,0,0,0-2.178.792,5.345,5.345,0,0,0-1.54,2.178,8.237,8.237,0,0,0-.56,3.085,8.326,8.326,0,0,0,.56,3.1,5.127,5.127,0,0,0,1.546,2.183,3.378,3.378,0,0,0,2.184.771,3.9,3.9,0,0,0,2.013-.644,6.748,6.748,0,0,0,1.891-1.8L142,52.446a10.077,10.077,0,0,1-3.045,2.854,6.644,6.644,0,0,1-7.721-.379,9.421,9.421,0,0,1-2.971-3.91,13.64,13.64,0,0,1-1.083-5.544,13.156,13.156,0,0,1,1.079-5.434,9.461,9.461,0,0,1,3.049-3.9,7.026,7.026,0,0,1,4.315-1.353,7.164,7.164,0,0,1,3.453.965,9.451,9.451,0,0,1,2.912,2.649L139.6,42.2A6.688,6.688,0,0,0,137.762,40.1Z",
    transform: "translate(268.455 108.772)",
    fill: "#363660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2478",
    "data-name": "Trac\\xE9 2478",
    d: "M143.791,39.837a6.087,6.087,0,0,0-2.4-.627,1.743,1.743,0,0,0-1.241.363,1.132,1.132,0,0,0-.339.462,1.559,1.559,0,0,0-.109.627,1.868,1.868,0,0,0,.1.632,1.535,1.535,0,0,0,.286.523,2.814,2.814,0,0,0,.943.742c.373.2.933.429,1.667.726a20.118,20.118,0,0,1,2.71,1.254,5.346,5.346,0,0,1,1.879,1.9,6.655,6.655,0,0,1,.771,3.3,7.182,7.182,0,0,1-.834,3.58,5.474,5.474,0,0,1-2.29,2.211,6.922,6.922,0,0,1-3.22.759,9.1,9.1,0,0,1-3.9-.924,9.812,9.812,0,0,1-3.357-2.326l1.593-4.257a10.015,10.015,0,0,0,2.884,2.261,6.191,6.191,0,0,0,2.884.891,2.172,2.172,0,0,0,1.456-.445,1.378,1.378,0,0,0,.4-.557,1.928,1.928,0,0,0,.137-.747,2.1,2.1,0,0,0-.106-.657,1.732,1.732,0,0,0-.292-.547,2.8,2.8,0,0,0-1-.759c-.4-.181-.958-.412-1.664-.676a17.08,17.08,0,0,1-2.688-1.2,5.242,5.242,0,0,1-1.8-1.848,6.25,6.25,0,0,1-.759-3.3,7.1,7.1,0,0,1,.784-3.4,5.337,5.337,0,0,1,2.2-2.261,6.678,6.678,0,0,1,3.319-.792,9.271,9.271,0,0,1,3.369.644,9.979,9.979,0,0,1,2.924,1.65l-1.618,4.455A12.632,12.632,0,0,0,143.791,39.837Z",
    transform: "translate(283.801 108.66)",
    fill: "#363660"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExvalSubtitle);
export default __webpack_public_path__ + "static/media/exval_subtitle.86d2c8f9b8f4afdbef747b5d1ffd1e75.svg";
export { ForwardRef as ReactComponent };